export const SPLIT_COMMISSIONS_ROUTE_PREFIX = "/commissions/split-commissions";

export const SPLIT_COMMISSIONS_ROUTE_PATHS = {
  list: { path: "*", to: SPLIT_COMMISSIONS_ROUTE_PREFIX },
};
